import { Amplify } from 'aws-amplify';
var AuthProvider = /** @class */ (function () {
    function AuthProvider() {
        // Allows to route the request to the correct environment trigger.
        // A limitation because of shared Cognito User Pool on DEV environments.
        this._env = 'dev';
    }
    Object.defineProperty(AuthProvider.prototype, "env", {
        get: function () {
            return this._env;
        },
        enumerable: false,
        configurable: true
    });
    AuthProvider.prototype.setup = function (config) {
        this._env = config.env;
        Amplify.configure({
            Auth: {
                region: config.cognitoUserPoolRegion,
                userPoolId: config.cognitoUserPoolId,
                userPoolWebClientId: config.cognitoClientId,
                authenticationFlowType: 'USER_SRP_AUTH',
                signUpVerificationMethod: 'code',
            },
        });
    };
    return AuthProvider;
}());
export var authProvider = new AuthProvider();
